export const HEADERS = {
	HEADER_REQUEST_FOR: 'Request For',
	HEADER_REQUESTED_BY: 'Requested By',
	HEADER_REQUESTED_DATE: 'Requested Date',
	HEADER_APPROVAL_FOR: 'Approval For',
	HEADER_JUSTIFICATION: 'Request Justification',
	HEADER_TRACKING_NUMBER: 'Tracking Number',
};

export const HEADER_DEFAULT_SORT = HEADERS.HEADER_REQUESTED_DATE;

export const HEADER_FILTER_BY = HEADERS.HEADER_REQUEST_FOR;
